import { Link } from '@rocketlane/rocket-router';
import { Space, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { IconShell } from 'components/atoms/icon-shell';
import { Header } from 'components/molecules/page/header';
import { ProductiveHeading05 } from 'components/styles';

const { Title } = Typography;

const HeaderTitle = styled(Title)`
  ${ProductiveHeading05};
  margin-bottom: 0px;
`;

const StyledHeader = styled(Header)<{ withBottomPadding?: boolean }>`
  padding-bottom: ${(props) =>
    props.withBottomPadding ? 'var(--spacing-02) !important' : '0'};
`;

const DummyLink = styled(Link)`
  pointer-events: none;
`;

export const IntegrationHeader = ({
  title,
  icon,
  subText,
  tabs,
  breadcrumbLink,
  breadcrumbText,
  learnMoreLink,
  disableBreadcrumb,
}: {
  title: React.ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
  icon?: React.ReactNode;
  subText?: React.ReactNode;
  tabs?: React.ReactNode;
  learnMoreLink?: React.ReactNode;
  disableBreadcrumb?: boolean;
}) => {
  const breadcrumbTextWithPlaceholder = breadcrumbText ?? (
    <FormattedMessage id="integrations" />
  );

  return (
    <>
      <StyledHeader
        withBottomPadding={!tabs}
        breadcrumbs={
          <Breadcrumb.Item>
            {disableBreadcrumb ? (
              <DummyLink
                to="/settings/integrations"
                data-cy="settings.integrations"
              >
                {breadcrumbTextWithPlaceholder}
              </DummyLink>
            ) : (
              <Link
                to={breadcrumbLink ?? '/settings/integrations'}
                data-cy="settings.integrations"
              >
                {breadcrumbTextWithPlaceholder}
              </Link>
            )}
          </Breadcrumb.Item>
        }
        title={
          <Space align="center">
            {icon ? <IconShell icon={icon} size="small" /> : null}
            <HeaderTitle data-cy="integrations.title" level={4}>
              {title}
            </HeaderTitle>
          </Space>
        }
        subText={
          <>
            {subText} {learnMoreLink}
          </>
        }
        tabs={tabs}
        sticky
      />
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </>
  );
};
